"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Measurements {
    constructor(measurementsRepository) {
        this.getMeasurements = (customer) => {
            return this.measurementsRepository.getMeasurements(customer.id);
        };
        this.measurementsRepository = measurementsRepository;
    }
    getMeasurementInfo(_customerId) {
        return Promise.resolve({
            nextMeasurement: {
                week: 8,
                date: {
                    iso8601: "2021-03-21",
                },
            },
            lastMeasurement: {
                id: "2021-03-12",
                photoSide: "side",
                photoFront: "front",
                photoBack: "back",
                createdAt: "2021-03-12",
                absoluteWeek: 4,
                weight: "100",
                shoulders: "99",
                breast: "80",
                waist: "70",
                legs: "45",
                height: "180",
            },
        });
    }
}
exports.default = Measurements;
//# sourceMappingURL=Measurements.js.map